/**
 * @desc 取消退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/cancel`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
